import React from 'react';
import { TitleEditorStoreEffects, TitleEditorStoreProvider, useTitle } from '@warehouse/title/domain';
import { ContentRelatedToRelationshipEditorAdapter } from './ContentRelatedToRelationshipEditor.adapter';
import { LoaderWrapper } from '../../../src/components/library/LoaderWrapper';

export function ContentRelatedToRelationshipEditorLoader({
	childUuid,
	parentUuid,
	onClose,
}: ContentRelatedToRelationshipEditorLoaderProps) {
	const childQueryOutput = useTitle({ uuid: childUuid });
	const parentQueryOutput = useTitle({ uuid: parentUuid });

	if (!childQueryOutput.data || !parentQueryOutput.data) {
		return (
			<div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<LoaderWrapper loading opacity={100} />
			</div>
		);
	}

	return (
		<TitleEditorStoreProvider titleUuid={parentUuid}>
			<TitleEditorStoreEffects />
			<ContentRelatedToRelationshipEditorAdapter
				childUuid={childUuid}
				childData={childQueryOutput.data}
				parentData={parentQueryOutput.data}
				onClose={onClose}
			/>
		</TitleEditorStoreProvider>
	);
}

interface ContentRelatedToRelationshipEditorLoaderProps {
	childUuid: string;
	parentUuid: string;
	onClose: (force?: boolean) => void;
}
